import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import axios from "./axios.js"
import VueSimpleAlert from "vue3-simple-alert"
import VueClipboard from 'vue3-clipboard'
import bootstrap from "bootstrap/dist/js/bootstrap";



// import firebase from 'firebase/app'
// import 'firebase/messaging';
// const firebaseConfig = {
//   apiKey: "AIzaSyB5-AKUSdluj1SubrqyM1BfLB1wcDMLMt0",
//   authDomain: "vuefiretest-4d6ed.firebaseapp.com",
//   projectId: "vuefiretest-4d6ed",
//   storageBucket: "vuefiretest-4d6ed.appspot.com",
//   messagingSenderId: "1024005003453",
//   appId: "1:1024005003453:web:7d2a6b2b01d2d6a6b7ffd4",
//   measurementId: "G-5D0WZC1Y49"
// };
// firebase.initializeApp(firebaseConfig);


// const messaging = firebase.messaging();

// requestPermission();

// function requestPermission() {
  
//   Notification.requestPermission().then((permission) => {
//     if (permission === 'granted') {
//       messaging.getToken({ vapidKey: "BMLd8NgmM2TzRH1_waAl1xhEyGDaOtSh9CTajNDkAYGGyc9Yb4YlYoYe8uEsi46YmPXFR_OPSsxrJlkahKhm2uo" }).then(
//         (currentToken) => {
          
//           store.dispatch('SETPUSH',currentToken);
//         }
//       )
//     }
//   });
// }

// messaging.onMessage(payload => {
//   var result = payload.data;
//   var title = result.title;
//   var body = result.body;
//   var image = result.image;
//   var link = result.link;
//   var Options = {
//       body: body,
//       image: image,
//       data: {
//           url: link
//       }
//   };
//   var notification = new Notification(title,Options);
//   notification.onclick = ()=> {
//     var urlToRedirect = Options.data.url;
//     notification.close();
//     location.href = urlToRedirect;
//   }
// })


const app = createApp(App);

app.config.globalProperties.axios = axios;
app.config.globalProperties.$alert = VueSimpleAlert;
app.config.globalProperties.clipboard = VueClipboard;
app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
})
app.use(bootstrap);
app.use(store);
app.use(router);
app.use(ArgonDashboard);
app.mount("#app");

